import { DebouncedTextInput, Toolbar } from "ra-friendsofbabba";
import { SimpleForm, required } from "react-admin";

import React from "react";
import StaffUserRoleInput from "./inputs/StaffUserRoleInput";
import StaffUserRoleOtherInput from "./inputs/StaffUserRoleOtherInput";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  inlineInput: {
    display: "inline-block",
    width: 300,
    float: "left",
    marginRight: theme.spacing(2),
  },
  clearBoth: {
    clear: "both",
    display: "block",
    width: 300,
  },
}));

const Form = ({ type, ...props }) => {
  const classes = useStyles();

  return (
    <SimpleForm
      {...props}
      toolbar={
        <Toolbar
          backTab={3}
          backReference="research-projects"
          backReferenceTarget="research_project_id"
        />
      }
    >
      <DebouncedTextInput
        className={classes.inlineInput}
        source="name"
        validate={required()}
        maxLength={100}
        fullWidth
      />
      <DebouncedTextInput
        className={classes.inlineInput}
        source="surname"
        validate={required()}
        maxLength={100}
        fullWidth
      />
      <StaffUserRoleInput
        className={classes.clearBoth}
        source="staff_user_role_id"
        fullWidth
      />
      <StaffUserRoleOtherInput
        className={classes.clearBoth}
        fullWidth
        source="staff_user_role_other"
      />

      <DebouncedTextInput
        source="relevance"
        validate={[required()]}
        maxLength={2000}
        fullWidth
        multiline
      />
    </SimpleForm>
  );
};
export default Form;
